
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Group } from "@/lib/types";

interface ProductFormGroupsProps {
  groups: Group[];
  selectedGroups: string[];
  handleGroupToggle: (groupId: string) => void;
}

const ProductFormGroups = ({
  groups,
  selectedGroups,
  handleGroupToggle,
}: ProductFormGroupsProps) => {
  if (groups.length === 0) {
    return null;
  }
  
  return (
    <div className="space-y-2">
      <Label>Groups (optional)</Label>
      <div className="border rounded-md p-3 space-y-2">
        {groups.map((group) => (
          <div key={group.id} className="flex items-center space-x-2">
            <Checkbox
              id={`group-${group.id}`}
              checked={selectedGroups.includes(group.id)}
              onCheckedChange={() => handleGroupToggle(group.id)}
            />
            <Label
              htmlFor={`group-${group.id}`}
              className="text-sm cursor-pointer"
            >
              {group.name}
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductFormGroups;
